/* istanbul ignore file */
import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class ShopifyMultipassStoreRequestError extends CodedError {
  static get errorName() {
    return errorCodes.shopifyMultipassStoreRequestError.code;
  }

  constructor(message: string = errorCodes.shopifyMultipassStoreRequestError.message) {
    super(message);
    this.code = errorCodes.shopifyMultipassStoreRequestError.code;
    this.message = `${message} ${errorCodes.shopifyMultipassStoreRequestError.code}`;
    this.name = errorCodes.shopifyMultipassStoreRequestError.name;
  }
}
